import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthConsumer } from "./AuthProvider";

export const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout();
            return <AbpnSpinner/>;
        }}
    </AuthConsumer>
);